// extracted by mini-css-extract-plugin
module.exports = {"title":"HowWorks_title__k4aFb","cardContent":"HowWorks_cardContent__30auY"};